import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdheridoControllerService } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'lib-initial-dae-dialog',
  templateUrl: './initial-dae-dialog.component.html',
  styleUrls: ['./initial-dae-dialog.component.scss']
})
export class InitialDaeDialogComponent {

  titulo: String = '';
  itemOpen: any;
  formGroup!: FormGroup;
  updateList: boolean = false;

  defaultFilter: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<InitialDaeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adheridoService: AdheridoControllerService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
  ) {
    this.itemOpen = this.data?.itemOpen;

    this.formGroup = this.formBuilder.group({
      fechaAdenda: [{ value: null, disabled: false }, { validators: Validators.compose([Validators.required]) }],
    });
  }

  cerrar() {
    this.dialogRef.close(null);
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (!this.formGroup.valid || !this.itemOpen?.id) {
      this.snackBarSrv.showSnackBar(
        'Debe completar la fecha obligatoria',
        'error'
      );
      return;
    }
    const fechaAdendaControl = this.formGroup.get('fechaAdenda')?.value;
    const fechaAdenda = this.toLocalDateString(fechaAdendaControl);
    if (!fechaAdenda) {
      this.snackBarSrv.showSnackBar(
        'La fecha adenda no tiene un formato valido',
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.adheridoService.generarDAEInicial(this.itemOpen.id, fechaAdenda).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'La declaración inicial ha sido generada correctamente.',
          'success'
        );
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        if (err?.error?.detail) {
          this.snackBarSrv.showSnackBar(err?.error?.detail, 'error');
        } else {
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error durante la generación de la declaración inicial',
            'error'
          );
        }
      },
    });

  }

  controlHasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName)
      && this.formGroup.controls[controlName].touched;
  }

  private toLocalDateString(value: any): string | null {
    if (!value) {
      return null;
    }

    if (typeof value.format === 'function') {
      return value.format('YYYY-MM-DD');
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      const year = value.getFullYear();
      const month = `${value.getMonth() + 1}`.padStart(2, '0');
      const day = `${value.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }

    return null;
  }

}
